export default __webpack_public_path__ + "static/media/gallery_03.d7c6bba7.jpg";